import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DoctorDetailsRes;
export const DoctorDetailsTodo = createAsyncThunk('DoctorDetails', async (id) => {

    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + `admin/doctor/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token')},
            params:{
                "company_id":localStorage.getItem('companyId')
            },
        })
        return DoctorDetailsRes = res.data

    } catch (error) {
        return DoctorDetailsRes = error.response.data
    }
});

const DoctorDetailsSlice = createSlice({
    name: 'DoctorDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(DoctorDetailsTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(DoctorDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default DoctorDetailsSlice.reducer; 